<style>
@import './fonts/stylesheet.css';
body * {
    color: #333;
    margin: 0;
    padding: 8px;
    box-sizing: border-box;
    font-family: Gotham Pro, sans-serif;
}
#observed {
    position: relative;
    min-height: 500px;
}
</style>
<script>
import { step, load, mutations, actions, preloader} from './mainStore.js';
import Order from './Order/Order.svelte';
import Step1 from './Step1/Step1.svelte';
import Step2 from './Step2/Step2.svelte';
import Step3 from './Step3/Step3.svelte';
import Step4 from './Step4/Step4.svelte';
import Step5 from './Step5/Step5.svelte';
import Preloader from './Preloader.svelte';
import { onMount } from 'svelte';
import config from './config';
addEventListener("popstate",function(e){
    let a = window.location.hash.split("#step")
    if (a.length >= 2) {
        mutations.setStep(a[1])
    } else {
        mutations.setStep(1)
    }
},false);
let responsiveClass = '';
onMount(async () => {
    try {
        await actions.getTracks()
        try {
            const resizeObserver = new ResizeObserver(entries => {
                mutations.setObservedRect(observed.getBoundingClientRect())
                if(entries[0].target.parentElement.offsetWidth < 765){
                     mutations.setResponsiveClass('middle')
                }else {
                     mutations.setResponsiveClass('')
                }
            });
            let obs = observed;

            resizeObserver.observe(obs);
        }catch (e) {
          if(observed.parentElement.offsetWidth < 765){
               mutations.setResponsiveClass('middle')
          }else {
               mutations.setResponsiveClass('')
          }
        }

    }
    catch (e){
        console.log(e)
    }
});
function dragEnd(event) {
    mutations.setDraggedItem(null);
    setTimeout(()=>{
        mutations.setIsDrag(false)
    }, 8)
}
let dragTimer;
function dragOver(event) {
   if(dragTimer){
       clearTimeout(dragTimer);
       dragTimer = undefined
   }
   dragTimer = setTimeout(()=>{dragEnd(event)},300)
}
function extractGetAll() {
    try {
        let vars = window.location.search.match(new RegExp('[^&?]+', 'gm'));
        let result = {};
        for (let i=0; i < vars.length; i++) {
        let r = vars[i].split('=');
            result[r[0]] =r[1];
        }
        return result;
    } catch (e) {
        return null
    }

}
function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
}
let orderId = findGetParameter("s_order_enk")
if(orderId) {
    mutations.setStep(0)
}

</script>
<div id="observed" on:dragover={dragOver} on:touchend={dragEnd}>
    {#if ($step == 0)}
        {#if ($load)}
            <Order orderId={orderId}/>
        {/if}
    {/if}
    {#if ($step == 1)}
        <Step1/>
    {/if}
    {#if ($step == 2)}
        <Step2/>
    {/if}
    {#if ($step == 3)}
        <Step3/>
    {/if}
    {#if ($step == 4)}
        <Step4 />
    {/if}
    {#if ($step == 5)}
        <Step5 />
    {/if}
    {#if ($preloader)}
        <Preloader />
    {/if}
</div>
